import { t } from "@lingui/macro";
import { useEffect, useState } from "react";

type propsType = {
  message: string;
  className?: string;
};

export const TypingText = ({ message, className = "" }: propsType) => {
  const [displayedMessage, setDisplayedMessage] = useState("");
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    if (isTyping) {
      const timeout = setTimeout(() => {
        setDisplayedMessage(message.slice(0, displayedMessage.length + 1));
        if (displayedMessage.length === message.length - 1) {
          setIsTyping(false);
        }
      }, 10); // Adjust this value to change typing speed

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [displayedMessage, isTyping, message]);

  return (
    <div className={className}>
      {t`${displayedMessage}`}
      {isTyping && <span className="animate-pulse">|</span>}
    </div>
  );
};
